import React, { useEffect } from 'react';
import { Award } from 'lucide-react';
import useOrganizationMemberActivityStore from '@/stores/AdminStore/OrganizationMemberActivityStore';
import { LoadingSpinner } from '@/Components/common';

interface Props { userId: string; }

const formatDate = (d: string | null) => (d ? new Date(d).toLocaleDateString() : '—');

const CertificatesTab: React.FC<Props> = ({ userId }) => {
  const { certificates, loadingCertificates, fetchCertificates } = useOrganizationMemberActivityStore();

  useEffect(() => { fetchCertificates(userId); }, [userId, fetchCertificates]);

  if (loadingCertificates) {
    return <div style={{ textAlign: 'center', padding: 32 }}><LoadingSpinner size="md" /></div>;
  }

  if (certificates.length === 0) {
    return (
      <div className="omact-empty">
        <Award size={40} color="#9ca3af" />
        <p>No certificates yet.</p>
      </div>
    );
  }

  return (
    <div>
      <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>Certificates ({certificates.length})</h3>
      <div className="omact-cert-grid">
        {certificates.map((c) => (
          <div className="omact-cert-card" key={`${c.source}-${c.id}`}>
            <div className="omact-cert-name">{c.certificate_name}</div>
            <div className="omact-cert-meta">
              <div>Issued: {formatDate(c.issued_date)}</div>
              {c.expiry_date && <div>Expires: {formatDate(c.expiry_date)}</div>}
              <div style={{ marginTop: 8 }}>
                <span className={`omact-badge omact-badge-${c.status}`}>{c.status}</span>
                <span style={{ marginLeft: 8, fontSize: 11, color: '#6b7280' }}>
                  {c.source === 'self' ? 'Self-uploaded' : 'Admin-issued'}
                </span>
              </div>
              {c.link && (
                <div style={{ marginTop: 8 }}>
                  <a href={c.link} target="_blank" rel="noreferrer" style={{ fontSize: 12 }}>View credential</a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CertificatesTab;
